export default __webpack_public_path__ + "static/media/hht1_ep20_timeline_q01_b.95a220f4.png";